import { useCallback, useEffect, useState } from 'react';
import { TrainingModalityService } from '../../services/training-modality/trainingModalityService';

const useTrainingModalities = (initialFilters = {}) => {
    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState({
        limit: 999999,
        filter_filters: { ...initialFilters }
    });

    const fetchTrainingModalities = async (extraFilters: any = null) => {
        try {
            const service = new TrainingModalityService();
            const response = await service.listForSelect(extraFilters ?? filters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((item: { id: string; name: string; code: string }) => ({
                    value: item.id,
                    label: `${item.code} - ${item.name}`,
                    code: item.code,
                    name: item.name,
                }));
                setData(mappedData);
            } else {
                setData([]);
            }
        } catch (error) {
            console.log('Error fetching training modalities:', error);
            setData([]);
        }
    };

    useEffect(() => {
        fetchTrainingModalities();
    }, [filters]);

    const updateTrainingModalitiesHookFilters = useCallback((newFilters: any) => {
        setFilters((prevFilters: any) => ({
            ...prevFilters,
            filter_filters: {
                ...(prevFilters?.filter_filters ?? {}),
                ...newFilters,
            }
        }));
    }, []);

    const getTrainingModalitiesList = () => data;

    return { fetchTrainingModalities, getTrainingModalitiesList, updateTrainingModalitiesHookFilters };
}

export default useTrainingModalities;

